function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/download");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "2_Schablone",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2.6.Schablone/Info-Terminal-Image",
  transform: "translate(-577.000000, -298.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Info",
  transform: "translate(330.000000, 115.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Typ-Copy-4",
  transform: "translate(20.000000, 53.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/download",
  transform: "translate(227.000000, 130.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#3CB950",
  strokeWidth: 0.5,
  fillOpacity: 0.1,
  fill: "#FFFFFF",
  cx: 12.5,
  cy: 12.5,
  r: 12.25
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5,13.287 L12.712,16.075 C12.594873,16.1919814 12.405127,16.1919814 12.288,16.075 L9.5,13.287 C9.38330008,13.1801496 9.33470975,13.0178412 9.37349865,12.8644421 C9.41228756,12.7110429 9.5321881,12.5913396 9.68565089,12.5528033 C9.83911368,12.5142669 10.0013419,12.5631243 10.108,12.68 L12.07,14.642 L12.07,7.43 C12.07,7.19251756 12.2625176,7 12.5,7 C12.7374824,7 12.93,7.19251756 12.93,7.43 L12.93,14.642 L14.892,12.68 C14.9986581,12.5631243 15.1608863,12.5142669 15.3143491,12.5528033 C15.4678119,12.5913396 15.5877124,12.7110429 15.6265013,12.8644421 C15.6652903,13.0178412 15.6166999,13.1801496 15.5,13.287 L15.5,13.287 Z M17.75,18 L7.25,18 C7.11192881,18 7,18.1119288 7,18.25 C7,18.3880712 7.11192881,18.5 7.25,18.5 L17.75,18.5 C17.8880712,18.5 18,18.3880712 18,18.25 C18,18.1119288 17.8880712,18 17.75,18 Z",
  id: "Shape",
  fill: "#3CB950",
  fillRule: "nonzero"
})))))));

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.8ca8bf86.svg";
export { ForwardRef as ReactComponent };